import { WorkItemSelectedTracking } from './interfaces/work-item-selected-tracking.interface';
import { Injectable } from '@angular/core';
import { WorkItem } from './interfaces/workitem-base.interface';
import { WorkItemEventParams, WorkItemEvents } from '../common/constants/analytics-enums';
import { Observable, ReplaySubject } from 'rxjs';
import { BcAnalytics } from '../analytics/analytics.service';
import { WorkItemTypes } from './constants/workitem-types';

interface WorkItemSelectedForService extends WorkItemSelectedTracking {
  timer?: number;
}

@Injectable()
export class WorkItemsTrackingService {
  public selectedItems: WorkItemSelectedForService = {};
  readonly waitForRenderTimeout = 500;
  private readonly _onChangeSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _visiblePanelCount: number;

  constructor(
    private _bcAnalytics: BcAnalytics
  ) {}

  public get onChange(): Observable<any> {
    return this._onChangeSubject.asObservable();
  }

  public updateDataByItemId(id: string, data: any): void {
    this.selectedItems[id] = {
      ...(this.selectedItems[id] || {}),
      ...data
    };
  }

  private getUnansweredMessages(item: WorkItem): number | null {
    const unansweredMessages = (<any>item).unansweredMessages;

    return typeof unansweredMessages === 'number' ? unansweredMessages : null;
  }

  public eventTrack({ id, type }: WorkItem): void {
    if (type === WorkItemTypes.LENS || type === WorkItemTypes.CHAT_PIN_INVITE) {
      const trackingParameters = {
        type,
        [WorkItemEventParams.PANEL_COUNT]: this.getVisiblePanelCount()
      };

      this._bcAnalytics.eventTrack(WorkItemEvents.WORK_ITEM_SELECTED, trackingParameters);
    } else {
      this._onChangeSubject.next(id);
    }
  }

  public track(item: WorkItem, data: any = {}): void {
    if (!this.selectedItems[item.id]) {
      this.selectedItems[item.id] = {};
    }

    clearTimeout(this.selectedItems[item.id].timer);
    this.selectedItems[item.id].timer = setTimeout(() => {
      const unansweredMessages = this.getUnansweredMessages(item);

      this.selectedItems[item.id] = {
        ...data,
        ...this.selectedItems[item.id],
        type: item.type,
        [WorkItemEventParams.PANEL_COUNT]: this.getVisiblePanelCount(),
        ...(unansweredMessages !== null ? { [WorkItemEventParams.UNREAD_MESSAGE_COUNT]: unansweredMessages } : {})
      };

      delete this.selectedItems[item.id].timer;

      this._bcAnalytics.eventTrack(WorkItemEvents.WORK_ITEM_SELECTED, this.selectedItems[item.id]);
    }, this.waitForRenderTimeout);
  }

  public destroyItem(id: string): void {
    delete this.selectedItems[id];
  }

  public setVisiblePanelCount(count: number): void {
    this._visiblePanelCount = count;
  }

  public getVisiblePanelCount(): number {
    return this._visiblePanelCount;
  }
}
